import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/6a70966f8295d50014940e97_1786106669755_c3292ed8/eventify/src/app/sign-up-login-screen/components/AuthScreen.tsx");
